import { render, staticRenderFns } from "./GenericInput.vue?vue&type=template&id=2fafe521&"
import script from "./GenericInput.vue?vue&type=script&lang=js&"
export * from "./GenericInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports